import React from "react";
import uiStates from "../data/private/uiStates.json";

export default function ErrorCard() {
  return (
    <div className="card p-6">
      <p className="text-sm font-semibold text-slate-900">
        {uiStates.error.title}
      </p>
      <p className="mt-2 text-sm text-slate-600">
        {uiStates.error.description}
      </p>
    </div>
  );
}
